var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgElectronicJournal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "false",
    focusable: "false",
    viewBox: "0 0 110 110",
    role: "img",
    width: "150px",
    height: "150px",
    fill: "none",
    id: "Receipt-id",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ElectronicJournal"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color-/-FOH",
    fill: "#000000",
    x: 0,
    y: 0,
    width: 111,
    height: 111
  }), /*#__PURE__*/React.createElement("text", {
    id: "EJ",
    fontFamily: "Futura-Bold, Futura",
    fontSize: 28,
    fontWeight: "bold",
    fill: "#FEFDFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 40,
    y: 98
  }, "EJ")), /*#__PURE__*/React.createElement("g", {
    id: "receipt",
    transform: "scale(2.8 2.8) translate(7.000000, 3.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M10.5 6.75H18m-7.5 3H18m-7.5 3h6M6 20.25h12c1.24 0 2.25-1.01 2.25-2.25V3.75h-12V18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M8.25 18c0 1.24-1.01 2.25-2.25 2.25S3.75 19.24 3.75 18v-5.25H6"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Receipt-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null);
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgElectronicJournal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/electronicJournal.6928572f9837d98e507375cd339057ca.svg";